module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseMacaque_m_normal.e587dbe5.png";